import { IListColumnMeta, EFieldType, IFormFieldsMeta } from 'shared/types/Page.interface';
import { UnFormalizedZipRequestDto, UnFormalizedZipResponseDto } from 'shared/api';

/**
 * Поля редактирования ЗИП админом: правятся только статус и описание.
 * Вложения прикладывает клиент при создании и здесь показываются на скачивание,
 * поэтому поля для их правки в форме нет.
 */
export const UNFORMALIZED_ZIP_EDIT_FORM_FIELDS: IFormFieldsMeta = [
  {
    name: 'engineId',
    label: 'ID двигателя',
    type: EFieldType.input,
    required: true,
  },
  {
    name: 'description',
    label: 'Описание',
    type: EFieldType.textarea,
  },
  {
    name: 'status',
    label: 'Статус',
    type: EFieldType.select,
    options: [
      { value: UnFormalizedZipRequestDto.status.NEW, label: 'Новый' },
      { value: UnFormalizedZipRequestDto.status.COMPLETED, label: 'Завершён' },
    ],
  },
] as const;

export const UNFORMALIZED_ZIP_TABLE_COLUMNS: IListColumnMeta = [
  {
    title: 'Владелец',
    type: EFieldType.input,
    dataIndex: 'ownerName',
    sortingPriority: 4,
  },
  {
    title: 'Компания',
    type: EFieldType.input,
    dataIndex: 'company',
    sortingPriority: 5,
  },
  {
    title: 'Статус',
    type: EFieldType.colored,
    dataIndex: 'status',
    colorMap: {
      [UnFormalizedZipResponseDto.status.NEW]: 'blue',
      [UnFormalizedZipResponseDto.status.COMPLETED]: 'green',
    },
    selectOptions: {
      [UnFormalizedZipResponseDto.status.NEW]: 'Новый',
      [UnFormalizedZipResponseDto.status.COMPLETED]: 'Обработан',
    },
    sortingPriority: 6,
  },
  {
    title: 'Дата создания',
    type: EFieldType.dateTime,
    dataIndex: 'createdAt',
    sourceFormat: 'YYYY-MM-DDTHH:mm:ss',
    targetFormat: 'DD.MM.YYYY HH:mm',
    sortingPriority: 7,
  },
] as const;
